import { Flex } from '@chakra-ui/react';
import { useState } from 'react';

import MainLayout from '@src/components/layouts/main';
import { FiCalendar, FiInfo, FiZap } from 'react-icons/fi';
import MainNav from '../../components/MainNav';
import Sidebar from '../../components/Sidebar';

import EventList from './components/EventList';
import BasicEntryList from './components/BasicEntryList';

const COMPONENT_MAP = {
  events: <EventList />,
  newFeatures: <BasicEntryList typeKey="new-features" typeLabel="Latest Updates" typeId={9} />,
  tipsTricks: <BasicEntryList typeKey="tips-and-tricks" typeLabel="Tips & Tricks" typeId={10} />,
};

export default function Home() {
  const [selected, setSelected] = useState('events');
  const navItems = [
    { key: 'events', label: 'Events', icon: FiCalendar },
    { key: 'newFeatures', label: 'Latest Updates', icon: FiZap },
    { key: 'tipsTricks', label: 'Tips & Tricks', icon: FiInfo },
  ];

  return (
    <MainLayout backgroundColor="gray.50" p={0}>
      <MainNav />
      <Flex
        flex="1"
        px={4}
        pb={4}
      >
        <Sidebar
          navItems={navItems}
          selected={selected}
          onSelect={setSelected}
        />
        <Flex
          flex="1"
          display="flex"
          flexDirection="column"
          pl={4}
          minW={0}
        >
          {COMPONENT_MAP[selected]}
        </Flex>
      </Flex>
    </MainLayout>
  );
}
